import {ApiUrls} from 'shared/config/model/urls';

import React, {useState} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {t} from '@lingui/core/macro';
import {toast} from 'react-toastify';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import EmailInput from 'shared/ui/Input/InputEmail';
import InputPassword from 'shared/ui/Input/InputPassword';
import {IChangeEmailForm} from 'entities/user';
import createHttpRequest from 'shared/api/http';

import ModalBlockButton from '../../../../shared/ui/Button/ModalBlockButton/ModalBlockButton';

import styles from './Profile.module.scss';

interface IChangeEmailFormProps {
    onClose: () => void;
}

const ChangeEmailForm: React.FC<IChangeEmailFormProps> = ({onClose}) => {
    const [newEmail, setNewEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSent, setIsFormSent] = useState(false);

    const {register, handleSubmit, formState, control} = useForm<IChangeEmailForm>({mode: 'onChange'});
    const {errors, isValid, isDirty} = formState;

    const onSubmit: SubmitHandler<IChangeEmailForm> = async(data) => {
        if(isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            await createHttpRequest({
                method: 'PUT',
                path: ApiUrls.USER_CHANGE_EMAIL,
                data,
                errorMessage: t`При изменении E-mail произошла ошибка`,
            });

            toast(`${t`Отправили письмо на`} ${data.email}`);
            setNewEmail(data.email);
            setIsFormSent(true);

        } catch (e) {
        }

        setIsLoading(false);
    };

    return (
        <>
            {
                isFormSent
                    ? <div>
                        <p className={styles.title}>
                            {t`На указанный вами адрес`} <b>{newEmail}</b> {t`отправлено письмо`},
                            {t`содержащее ссылку для изменения E-mail`}.
                        </p>
                    </div>
                    :  <form onSubmit={handleSubmit(onSubmit)}>
                        <ModalBodyWrapper>
                            <FormGroupWithError>
                                <EmailInput
                                    name="email"
                                    register={register}
                                    control={control}
                                    required
                                    placeholder={t`Новый E-mail`}
                                    placeholderToLabel
                                />
                            </FormGroupWithError>
                            <FormGroupWithError
                                error={errors?.password?.message}
                            >
                                <InputPassword
                                    register={register}
                                    name="password"
                                    placeholder={t`Пароль`}
                                    placeholderToLabel
                                    control={control}
                                />
                            </FormGroupWithError>
                        </ModalBodyWrapper>
                        <ModalBlockButton
                            primaryButtonText={t`Изменить E-mail`}
                            primaryButtonType="submit"
                            primaryButtonLoading={isLoading}
                            primaryButtonDisabled={!(isValid && isDirty)}
                            secondaryButtonOnClick={onClose}
                        />
                    </form>
            }
        </>
    );
};

export default ChangeEmailForm;